import React, {useState, useEffect} from 'react';
import {Spin} from 'antd';
import {getAuthUserInfo} from '@/api/open';

export default function WxCodePage() {
    useEffect(() => {
        let url = window.location.href;
        console.log(url);
        let tempArr = url.split('?');
        if (tempArr.length > 1) {
            let code = tempArr[1].split('&')[0].split('=')[1];
            // localStorage.setItem('code', code);
            getAuthUserInfo(code).then(res => {
                alert(JSON.stringify(res.data));
                window.location.href =
                    'https://federation.abbvie.com/idp/startSSO.ping?PartnerSpId=abbvie:wecom:prod:saml20:sp';
                // console.log(res);
            });
        }
    }, []);

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', marginTop: '60px'}}>
            <Spin spinning={true} style={{margin: 'auto'}} />
        </div>
    );
}
